import { Package } from '@features/DynamicPackagesConfigurationWizard/types';

export const isDynamicPackage = (packageData?: Package | null) =>
  !!packageData?.experiences?.length || !!packageData?.restaurants?.length;
